import React from "react";
import * as yup from "yup";
import { timeUnits } from "../../../../constants";
import AddAttachment from "../../AssetForms/AddAttachment";
import CompleteButton from "../../Buttons/CompleteButton";
import Checkbox from "../../Checkbox/Checkbox";
import Dropdown from "../../Dropdown/Dropdown";
import Input from "../../Input/Input";
import PopupHeader from "../PopupHeader";
import useMarkCompletePopupData from "./useMarkCompletePopupData";

const MarkCompletePopup = ({ popupData, closePopup }) => {
  const {
    name,
    duration,
    timeUnit,
    comment,
    filesToAdd,
    handleRemoveAttachment,
    handleFilesAdded,
    handleSubmitClick,
    setComment,
    setTimeUnit,
    handleDurationChange,
    setCompleteStatus,
    completeStatus,
    initialState,
    checkBoxText,
    isSaving,
    disableSubmit,
  } = useMarkCompletePopupData({
    popupData,
    closePopup,
  });

  return (
    <>
      <PopupHeader headerTitle="Mark Complete" closePopup={closePopup} />
      <div
        className={`relative p-5 overflow-y-scroll ${isSaving && "loading"}`}
        style={{ width: popupData?.popupWidth || "500px", maxHeight: "500px" }}
      >
        <h1 className="text-xl font-semibold tracking-wider text-gray-400 truncate">
          {name}
        </h1>
        <div
          className="px-6 py-5 mt-4 flex flex-col gap-6 relative"
          style={{
            border: "1px solid #CACACA",
            borderRadius: "6px",
          }}
        >
          <div>
            <span className="font-semibold text-gray-450">Duration</span>
            <Input
              label={null}
              placeholder="Duration"
              required
              type="number"
              minValue={0}
              value={duration}
              validation={yup.number().min(0).typeError("Required").required()}
              onChange={(val) => handleDurationChange(val)}
            />
          </div>
          <div>
            <span className="font-semibold text-gray-450">Time Unit</span>
            <Dropdown
              value={timeUnit}
              onChange={(val) => setTimeUnit(val)}
              options={timeUnits}
              disableSort
              disableClear
            />
          </div>
          {popupData?.item?.spaces.length ? (
            <div className="flex flex-row items-center gap-2">
              <Checkbox
                checked={completeStatus.spaces}
                onChange={(val) =>
                  !initialState.spaces &&
                  setCompleteStatus((prev) => ({ ...prev, spaces: val }))
                }
                size={6}
              />
              <p className="text-gray-300 text-md font-normal w-full">
                {checkBoxText.spaces}
              </p>
            </div>
          ) : null}
          {popupData?.item?.assets.length ? (
            <div className="flex flex-row items-center gap-2">
              <Checkbox
                checked={completeStatus.assets}
                onChange={(val) =>
                  !initialState.assets &&
                  setCompleteStatus((prev) => ({ ...prev, assets: val }))
                }
                size={6}
              />
              <p className="text-gray-300 text-md font-normal w-full">
                {checkBoxText.assets}
              </p>
            </div>
          ) : null}
          {popupData?.item?.steps.length ? (
            <div className="flex flex-row items-center gap-2">
              <Checkbox
                checked={completeStatus.steps}
                onChange={(val) =>
                  !initialState.steps &&
                  setCompleteStatus((prev) => ({ ...prev, steps: val }))
                }
                size={6}
              />
              <p className="text-gray-300 text-md font-normal w-full">
                {checkBoxText.steps}
              </p>
            </div>
          ) : null}
          <div>
            <span className="font-semibold text-gray-450">Comment</span>
            <textarea
              placeholder="Comment"
              style={{
                color: "#585858",
              }}
              rows="1"
              className="bg-backgroundGreen w-full p-4 rounded border border-gray-150 resize-none"
              onChange={(e) => setComment(e.target.value)}
              value={comment}
            />
          </div>
          <div>
            <AddAttachment
              files={filesToAdd}
              onFilesAdded={handleFilesAdded}
              onRemove={handleRemoveAttachment}
              onFiles
              sort
            />
          </div>
        </div>
      </div>
      <div className="pl-6 p-4">
        <CompleteButton onClick={handleSubmitClick} disabled={disableSubmit} />
      </div>
    </>
  );
};

export default MarkCompletePopup;
